import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';
import { professional } from 'src/types/product';
// types
// import { IProductItem, professional } from 'src/types/product';

export function useGetProfessional(page=1) {
    // const URL = endpoints.test.category;
    const URL = `${endpoints.professional.getprofessional}?page=${page}`;
      //  const URL = `${endpoints.advertisement.getalladvt}`;
    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);
    const memoizedValue = useMemo(
      () => ({
        professionaldata: (data?.results as professional[]) || [],
        productsLoading: isLoading,
        total:(data?.total as number || 0),
        productsError: error,
        productsValidating: isValidating,
        // productsEmpty: !isLoading && !data?.data.length,
      }),
      [data?.results,  data?.total,error, isLoading, isValidating]
    );
    return memoizedValue;
  }














